<declarative-form
  #declarativeForm
  [page]="page()"
  [pages]="pages()"
  [validationStrategy]="validationStrategy()"
  (isValidChanged)="handleIsValidChanged($event)"
></declarative-form>

<next-form-actions
  [actions]="page().navigation"
  (action)="handleAction($event, declarativeForm)"
  class="inline-block"
></next-form-actions>
